import { SxProps, TextField } from '@mui/material';
import { TextFieldProps } from '@mui/material/TextField/TextField';
import React from 'react';

export interface TextareaProps
  extends Omit<
    TextFieldProps,
    'slotProps' | 'minRows' | 'multiline' | 'error'
  > {
  error?: string;
  info?: string;
}

const Textarea = ({ error, info, ...rest }: TextareaProps) => (
  <TextField
    slotProps={{ inputLabel: { shrink: true } }}
    minRows={4}
    multiline
    size="small"
    variant="outlined"
    margin="none"
    fullWidth
    error={!!error}
    helperText={error ?? info}
    sx={sx}
    {...rest}
  />
);

const sx: SxProps = {
  '& .MuiFormHelperText-root': { marginLeft: 0, marginTop: '0.125rem' },
};

export default Textarea;
